import * as React from "react";
import { Button, Form, Message, Modal } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";

import { useDispatch } from "@teamprevent/admin-redux";

import * as moment from "moment";

import { navigateToParentRoute } from "@teamprevent/common/routing/actions";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";
import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import {
    SUBMIT_DID_NOT_ATTEND,
    submitDidNotAttendMultipleAppointments
} from "../actions";

interface OwnProps {
    tasks: TaskModel[];
    disabled?: boolean;
    appointmentEndDate: moment.Moment;
}

export const DidNotAttendAll: React.FunctionComponent<OwnProps> = (props) => {
    const dispatch = useDispatch();

    const [open, setOpen] = React.useState<boolean>(false);
    const [openConfirmation, setOpenConfirmation] = React.useState<boolean>(false);
    const [comment, setComment] = React.useState<string | undefined>(undefined);

    const provideComment = React.useCallback(() => setOpen(true), []);

    const submitDidNotAttend = React.useCallback(() => setOpenConfirmation(true), []);

    const cancelDidNotAttend = React.useCallback(() => {
        setOpen(false);
        setComment(undefined);
    }, []);

    const onConfirmationClose = React.useCallback(() => setOpenConfirmation(false), []);

    const onConfirmationConfirm = React.useCallback(async () => {
        if (comment === undefined) { return; }
        setOpen(false);
        setOpenConfirmation(false);
        await dispatch(submitDidNotAttendMultipleAppointments(props.tasks, comment));
        dispatch(navigateToParentRoute());
    }, [dispatch, props.tasks, comment]);

    const canConfirmDna = props.appointmentEndDate.isBefore(moment());

    return (
        <>
            <IsLoadingButton requestNames={SUBMIT_DID_NOT_ATTEND} onClick={provideComment} disabled={props.disabled} content="DNA" secondary />
            <Modal open={open} size="small" closeOnDimmerClick={false}>
                <Modal.Header>Provide comment</Modal.Header>
                <Modal.Content>
                    <Form>
                        <Input.Textarea
                            label={"Comment"}
                            value={comment}
                            onChange={setComment}
                        />
                        <Message warning visible>These comments will be seen in the manager and employee portal.</Message>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={cancelDidNotAttend}>Cancel</Button>
                    <Button content="Save" onClick={submitDidNotAttend} />
                </Modal.Actions>
            </Modal>
            <Modal open={openConfirmation} size="small">
                <Modal.Header>
                    DNA
                </Modal.Header>
                <Modal.Content>
                    <span>
                        {
                            canConfirmDna ? "If you set this appointment to a DNA you will be unable to complete this appointment " +
                                "and notifications of the DNA will be sent to the employee and any Managers linked " +
                                "to the case - are you sure you wish to continue?" :
                                "You cannot set this task to a DNA until after the end of the appointment."
                        }
                    </span>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={onConfirmationClose}>Cancel</Button>
                    {canConfirmDna &&
                        <Button
                            primary
                            onClick={onConfirmationConfirm}
                        >
                            Confirm
                        </Button>
                    }
                </Modal.Actions>
            </Modal>
        </>);
};
